import { useState } from "react";
import { AffiliateRequest } from "./Campaign/AffiliateRequest";
import { AffiliateAccept } from "./Campaign/AffiliateAccept";
import { AffiliateReject } from "./Campaign/AffiliateReject";
import { AffiliateProposalRequest } from "./Affiliate/AffiliateProposalRequest";
import { AffiliateProposalAccept } from "./Affiliate/AffiliateProposalAccept";
import { AffiliateProposalReject } from "./Affiliate/AffiliateProposalReject";
import { FinancialWithdrawalApproved } from "./Financial/FinancialWithdrawalApproved";
import { FinancialWithdrawalRequest } from "./Financial/FinancialWithdrawalRequest";
import { FinancialWithdrawalReject } from "./Financial/FinancialWithdrawalReject";
import { AffiliateProposalBlock } from "./Affiliate/AffiliateProposalBlock";
import { AffiliateBlock } from "./Campaign/AffiliateBlock";
import { FinancialCommissionReceived } from "./Financial/FinancialCommissionReceived";

// ---------------------------------------------------------------------------
// Registry — add new templates here
// ---------------------------------------------------------------------------
const PAGES: { key: string; label: string; group: string; html: string }[] = [
  {
    key: "aff-request",
    label: "Afiliado: Requisição",
    group: "Campanha",
    html: AffiliateRequest,
  },
  {
    key: "aff-accept",
    label: "Afiliado: Aceitou",
    group: "Campanha",
    html: AffiliateAccept,
  },
  {
    key: "aff-reject",
    label: "Afiliado: Rejeitou",
    group: "Campanha",
    html: AffiliateReject,
  },
  {
    key: "aff-block",
    label: "Afiliado: Bloqueado",
    group: "Campanha",
    html: AffiliateBlock,
  },
  // Affiliate
  {
    key: "aff-prop-request",
    label: "Afiliado: Proposta",
    group: "Afiliado",
    html: AffiliateProposalRequest,
  },
  {
    key: "aff-prop-accept",
    label: "Afiliado: Aceita",
    group: "Afiliado",
    html: AffiliateProposalAccept,
  },
  {
    key: "aff-prop-reject",
    label: "Afiliado: Recusada",
    group: "Afiliado",
    html: AffiliateProposalReject,
  },
  {
    key: "aff-prop-block",
    label: "Afiliado: Bloqueada",
    group: "Afiliado",
    html: AffiliateProposalBlock,
  },
  // Financial
  {
    key: "fin-withdrawal-request",
    label: "Financeiro: Saque Requisitado",
    group: "Financeiro",
    html: FinancialWithdrawalRequest,
  },
  {
    key: "fin-withdrawal-approved",
    label: "Financeiro: Saque Aprovado",
    group: "Financeiro",
    html: FinancialWithdrawalApproved,
  },
  {
    key: "fin-withdrawal-reject",
    label: "Financeiro: Saque Negado",
    group: "Financeiro",
    html: FinancialWithdrawalReject,
  },
  // Commission
  {
    key: "fin-commission-request",
    label: "Financeiro: Comissão Recebida",
    group: "Financeiro: Comissão",
    html: FinancialCommissionReceived,
  },
];

export function NotificationTest() {
  const [activeKey, setActiveKey] = useState<string>(PAGES[0].key);

  const active = PAGES.find((p) => p.key === activeKey)!;

  return (
    <div className="container-fluid py-0">
      {/* Header */}
      <div
        className="d-flex align-items-center gap-3 px-4 py-3 border-bottom"
        style={{
          background: "linear-gradient(135deg, #0c1322 0%, #162038 100%)",
        }}
      >
        <span style={{ fontSize: "1.3rem" }}>🧪</span>
        <div>
          <h6 className="mb-0 fw-bold text-white">
            Notification Template Tester
          </h6>
          <small className="text-white" style={{ fontSize: "0.8rem" }}>
            Visualize os templates antes de subir para o banco
          </small>
        </div>
        <span
          className="badge ms-auto"
          style={{
            background: "rgba(255,255,255,0.12)",
            color: "#93c5fd",
            fontSize: "0.72rem",
          }}
        >
          {PAGES.length} templates
        </span>
      </div>

      <div className="row g-0" style={{ minHeight: "calc(100vh - 65px)" }}>
        {/* Sidebar */}
        <div
          className="col-md-3 border-end p-3"
          style={{ background: "#f7f8fc" }}
        >
          {Array.from(new Set(PAGES.map((p) => p.group))).map((group) => (
            <div key={group} className="mb-2">
              <div
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  color: "#a0aec0",
                  padding: "4px 8px",
                }}
              >
                ▶️ {group}
              </div>
              {PAGES.filter((p) => p.group === group).map((page) => {
                const isActive = activeKey === page.key;
                return (
                  <button
                    key={page.key}
                    type="button"
                    onClick={() => setActiveKey(page.key)}
                    className="btn btn-sm w-100 text-start mb-1"
                    style={{
                      borderRadius: 8,
                      fontSize: "0.82rem",
                      fontWeight: isActive ? 700 : 500,
                      padding: "8px 12px",
                      background: isActive
                        ? "linear-gradient(135deg, #0c1322, #162038)"
                        : "transparent",
                      color: isActive ? "#fff" : "#4a5568",
                      border: "none",
                    }}
                  >
                    {page.label}
                  </button>
                );
              })}
            </div>
          ))}
        </div>

        {/* Preview */}
        <div className="col-md-9 p-4" style={{ background: "#eef0f5" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: "10px",
              border: "1px solid #e8ecf5",
            }}
          >
            {/* Preview bar */}
            <div
              className="d-flex align-items-center gap-2 px-3 py-2 border-bottom"
              style={{ fontSize: "0.75rem", color: "#a0aec0" }}
            >
              <span
                className="fw-bold"
                style={{ textTransform: "uppercase", letterSpacing: "0.06em" }}
              >
                Preview
              </span>
              <span>—</span>
              <span style={{ color: "#4a5568", fontWeight: 600 }}>
                {active.group} › {active.label}
              </span>
              <span
                className="ms-auto px-2 py-1 rounded"
                style={{
                  background: "#f1f5f9",
                  color: "#64748b",
                  fontSize: "0.7rem",
                }}
              >
                {active.key}
              </span>
            </div>

            {/* Rendered HTML — exactly what goes into the DB */}
            <div
              className="p-4"
              style={{
                fontSize: "0.88rem",
                lineHeight: 1.75,
                color: "#2d3748",
              }}
              dangerouslySetInnerHTML={{ __html: active.html }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
